import React from "react";
import { LegalPage, LegalSection, LegalIntro, LegalList, LegalAddress } from "../../components/LegalPage";

/* Verbatim from Dr_Tania_Approved_Legal_Page_Copy_2026-08-03.md.
 * Section 12: two phone numbers retained exactly as supplied. */

export default function MedicalDisclaimer() {
  return (
    <LegalPage
      title="Medical Disclaimer"
      effectiveDate="Effective date: 3 August 2026"
      seoTitle="Medical Disclaimer | Dr Tania Gurdip Singh"
      seoDescription="The information on drtaniasingh.com, including Conditions, Articles, Clinical Insights and answers developed from submitted questions, is provided for general education."
      canonical="/medical-disclaimer"
    >
      <LegalSection n={1} title="General education only">
        <p>
          The information on drtaniasingh.com, including Conditions, Articles, Clinical
          Insights and answers developed from submitted questions, is provided for general
          education.
        </p>
        <p>
          It is not intended to diagnose a condition, prescribe treatment or replace
          individual assessment by a qualified medical professional.
        </p>
      </LegalSection>

      <LegalSection n={2} title="Individual circumstances matter">
        <p>Pregnancy care depends on factors that may include:</p>
        <LegalList items={[
          "Gestational age",
          "Previous pregnancy outcomes",
          "Maternal medical conditions",
          "Current symptoms",
          "Examination findings",
          "Laboratory trends",
          "Ultrasound and Doppler findings",
          "Medication exposure",
          "Fetal condition",
          "Access to appropriate monitoring and emergency care",
        ]}/>
        <p>General information cannot safely account for all these factors.</p>
      </LegalSection>

      <LegalSection n={3} title="No doctor–patient relationship from reading or submitting">
        <p>
          Reading the website, submitting a consultation request, sending a question or
          receiving an automated acknowledgement does not create a doctor–patient
          relationship.
        </p>
        <p>A clinical relationship begins only when a consultation is formally accepted and conducted.</p>
      </LegalSection>

      <LegalSection n={4} title="Emergencies">
        <p>
          The website, consultation form and Ask a Question page are not monitored for
          emergencies.
        </p>
        <p>Seek urgent medical care where you experience symptoms such as:</p>
        <LegalList items={[
          "Heavy vaginal bleeding",
          "Severe abdominal pain",
          "Collapse, fainting or marked weakness",
          "Seizure",
          "Severe breathing difficulty",
          "Severe headache with visual disturbance",
          "Sudden significant swelling or serious deterioration",
          "Reduced or absent fetal movements",
          "Suspected leaking of fluid",
          "Labour symptoms",
          "Any symptom that feels severe, rapidly progressive or unsafe to manage at home",
        ]}/>
        <p>This list is illustrative and not exhaustive.</p>
      </LegalSection>

      <LegalSection n={5} title="Medicines and treatment">
        <p>
          Do not start, stop or change a medicine, injection, supplement, hormone,
          anticoagulant or other treatment solely because it is discussed on this website.
        </p>
        <p>
          Medication safety and treatment decisions may depend on dose, indication,
          gestational age, medical history, examination and monitoring.
        </p>
        <p>Discuss treatment changes with the clinician responsible for your care.</p>
      </LegalSection>

      <LegalSection n={6} title="Tests, reports and scan findings">
        <p>
          The meaning of a laboratory result, ultrasound finding or medical report depends on
          its complete context.
        </p>
        <p>
          A value described as normal or abnormal in an educational article may not have the
          same significance in every pregnancy.
        </p>
        <p>Public forms should not be used to submit reports or seek interpretation of an individual result.</p>
      </LegalSection>

      <LegalSection n={7} title="Teleconsultation limitations">
        <p>
          A teleconsultation may be appropriate for some questions but not for every medical
          situation.
        </p>
        <p>
          Dr Tania or the clinical team may recommend an in-person examination,
          investigation, hospital assessment or care from a local clinician where this is
          safer or more appropriate.
        </p>
        <p>The communication format for a teleconsultation is coordinated individually.</p>
      </LegalSection>

      <LegalSection n={8} title="No guarantee of outcome">
        <p>
          High-risk pregnancy care seeks to identify risk, improve preparation and support
          appropriate decisions. It cannot guarantee a particular maternal, fetal or
          pregnancy outcome.
        </p>
        <p>Past results, patient experiences and educational examples do not predict the outcome of another case.</p>
      </LegalSection>

      <LegalSection n={9} title="Currency of information">
        <p>Medical evidence, recommendations and professional guidance evolve.</p>
        <p>
          Reasonable efforts are made to maintain accurate content, but a page may not
          immediately reflect every newly published guideline, warning or regulatory change.
        </p>
        <p>Publication and meaningful-update dates should be displayed where appropriate.</p>
      </LegalSection>

      <LegalSection n={10} title="External information">
        <p>
          References and external links may be included to support further reading. We do not
          control later changes made by external publishers, institutions or websites.
        </p>
      </LegalSection>

      <LegalSection n={11} title="Responsibility and statutory rights">
        <p>
          You are responsible for obtaining individual medical assessment before relying on
          website content for a healthcare decision.
        </p>
        <p>
          To the extent permitted by law, responsibility is not accepted for harm resulting
          from using general educational information as a substitute for professional
          diagnosis, examination or treatment.
        </p>
        <p>Nothing in this disclaimer restricts any right or liability that cannot lawfully be restricted.</p>
      </LegalSection>

      <LegalSection n={12} title="Contact">
        <p>For administrative questions about the website:</p>
        <LegalAddress>
          <strong>HIGH RISKK PREGNANCY CLINIC</strong><br/>
          A-78A, Veer Savarkar Marg<br/>
          Opposite SBI Bank, Lajpat Nagar II<br/>
          New Delhi – 110024
        </LegalAddress>
        <p>For appointment coordination:</p>
        <LegalAddress>
          <strong>+91 92117 31733</strong>
        </LegalAddress>
        <p>For teleconsultation and WhatsApp:</p>
        <LegalAddress>
          <strong>+91 96259 30047</strong>
        </LegalAddress>
      </LegalSection>
    </LegalPage>
  );
}
